module.exports = __webpack_public_path__ + "img/icon-diccionary-2.893d801a.svg";